import { render } from "./Hot.vue?vue&type=template&id=615eab4a&scoped=true"
import script from "./Hot.vue?vue&type=script&lang=js"
export * from "./Hot.vue?vue&type=script&lang=js"

import "./Hot.vue?vue&type=style&index=0&id=615eab4a&lang=less&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-615eab4a"]])

export default __exports__